import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { Bell, CheckCircle2, XCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const unread = items.filter((n) => !n.read).length;

  const load = useCallback(() => {
    api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [load]);

  const markAll = async () => {
    if (unread === 0) return;
    await api.post("/notifications/read_all").catch(() => {});
    setItems((prev) => prev.map((n) => ({ ...n, read: true })));
  };

  return (
    <Popover onOpenChange={(o) => { if (o) markAll(); }}>
      <PopoverTrigger asChild>
        <button data-testid="notif-bell" className="relative text-zinc-300 hover:text-white transition-colors p-2">
          <Bell className="w-5 h-5" />
          {unread > 0 && (
            <span data-testid="notif-badge" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center text-[10px] font-bold bg-primary text-white rounded-full">
              {unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 bg-[#0a0a0a] border-zinc-800 p-0 max-h-96 overflow-y-auto">
        <div className="px-4 py-3 border-b border-zinc-800 font-display font-bold text-white text-sm">
          Thông báo
        </div>
        {items.length === 0 ? (
          <div className="px-4 py-8 text-center text-zinc-600 text-sm">Chưa có thông báo nào.</div>
        ) : (
          <div className="divide-y divide-zinc-800">
            {items.map((n) => (
              <div key={n.id} data-testid={`notif-${n.id}`} className="px-4 py-3 flex gap-3 items-start hover:bg-white/5 transition-colors">
                {n.type === "report_approved" ? (
                  <CheckCircle2 className="w-4 h-4 text-green-400 mt-0.5 shrink-0" />
                ) : (
                  <XCircle className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                )}
                <div>
                  <p className="text-sm text-zinc-200 leading-snug">{n.message}</p>
                  <span className="text-[11px] text-zinc-600">{new Date(n.created_at).toLocaleString("vi-VN")}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
